<template>
	<div class="user-burger-menu">
		<div class="flex justify-between items-center">
			<a v-show="false" class="mr-20 flex justify-between items-center font-uppercase" href="" disabled @click.prevent>
				<SVGIcon class="mr-10" icon-name="vidswap" height="20" width="15" :change-colors="false" />
				<span>Vidswap</span>
			</a>
			<span class="user-burger-menu-user-name text-truncate">{{ user.name }}</span>
			<popover-menu>
				<template #menu-toggle="{ toggle }">
					<div class="flex justify-between items-center pointer" @click.prevent="toggle">
						<user-icon class="ml-10 mr-10" @click.prevent />
						<a class="toggle-menu-arrow" @click.prevent />
					</div>
				</template>

				<template #default="{ close }">
					<div class="user-menu">
						<button class="user-menu-close text-white" @click.prevent="close">
							<SVGIcon icon-name="cancel" width="10px" height="10px" />
						</button>
						<div>
							<div class="text-center mb-25">
								<user-icon size="large" show-letter />
							</div>

							<div class="text-center font-uppercase">
								<nuxt-link
									class="user-menu-logout"
									:to="{ name: 'auth-index-login', params: { logout: true } }"
									:title="$tc('actions.logout')"
								>
									<SVGIcon icon-name="logout" width="11" height="10" fill="ff8888" />
									<span>{{ $tc('actions.logout') }}</span>
								</nuxt-link>
							</div>

							<div class="user-display text-center">
								<div class="user-name font-uppercase">
									{{ user.name }}
								</div>
								<div class="user-email">
									{{ user.email }}
								</div>
							</div>

							<div class="user-menu-links font-uppercase">
								<nuxt-link v-if="permissions.isVerifiedAdmin" class="user-menu-link" to="/profile/account/" :title="$tc('events.sideMenu.myAccountLink')">
									<SVGIcon icon-name="user-logo" width="16" height="16" fill="transparent" />
									<span>{{ $tc('events.sideMenu.myAccountLink') }}</span>
								</nuxt-link>
								<nuxt-link v-show="false" class="user-menu-link" to="/profile/my-pixellot/" :title="$tc('events.sideMenu.userGuidesLink')">
									<SVGIcon icon-name="info" width="16" height="16" fill="white" />
									<span>{{ $tc('events.sideMenu.userGuidesLink') }}</span>
								</nuxt-link>
								<a class="user-menu-link" href="/support-center/" :title="$tc('events.sideMenu.helpLink')">
									<SVGIcon icon-name="help" width="16" height="16" fill="white" />
									<span>{{ $tc('events.sideMenu.helpLink') }}</span>
								</a>
							</div>
						</div>
					</div>
				</template>
			</popover-menu>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SVGIcon } from '~/components/interface'
import UserIcon from '~/components/particles/UserIcon'
import PopoverMenu from '~/components/events/PopoverMenu'

export default {
	name: 'UserMenu',
	components: { PopoverMenu, UserIcon, SVGIcon },
	computed: {
		...mapGetters({ user: 'user/user', permissions: 'user/permissions' })
	}
}
</script>

<style lang="scss">
	.user-burger-menu {
		position: relative;
		max-width: calc(min(50%, 300px));

		.popover-menu-content {
			bottom: initial !important;
		}

		.user-burger-menu-user-name {
			color: $white;
			@include respond-below(phone) {
				display: none;
			}
		}

		.toggle-menu-arrow {
			display: inline-block;
			width: 7px;
			height: 7px;
			border-top: 1.4px solid #a5d6ed;
			border-right: 1.4px solid #a5d6ed;
			transform: rotate(135deg);
		}

		.user-menu {
			padding: 30px 20px 20px;
			min-width: 234px;
			min-height: 200px;

			&-close {
				position: absolute;
				top: 15px;
				right: 15px;

				&:hover {
					color: $thin-blue;
				}
			}

			.user-menu-logout {
				display: inline-block;
				color: $white;
				font-size: 11.2px;
				font-weight: 500;
				letter-spacing: 0.45px;
				transition: 0.3s;

				span {
					color: inherit;
					padding-left: 8px;
				}

				&:hover {
					color: $thin-blue;
					transform: translateX(7.5%) scale(1.1);
				}
			}

			.user-display {
				padding: 18px 0;
				border-bottom: solid 0.5px rgba($white, 0.2);

				.user-name {
					font-size: 14px;
					font-weight: 500;
				}

				.user-email {
					margin-top: 4px;
					font-size: 11px;
					opacity: 0.7;
				}
			}

			.user-menu-links {
				margin-top: 20px;

				.user-menu-link {
					display: flex;
					align-items: center;
					margin-bottom: 12px;
					color: $white;
					font-size: 12px;
					font-weight: 500;
					transition: 0.3s;

					span {
						margin-left: 17px;
					}

					&:hover {
						color: $thin-blue;
						transform: translateX(7.5%) scale(1.1);
					}
				}
			}
		}
	}
</style>
